export default __webpack_public_path__ + "static/media/Mortend-Regular.e0d3ef4b.woff";